module.exports = "<h1 id=\"标签--d-tag\">标签  d-tag</h1>\n<h2 id=\"扩展说明\">扩展说明</h2>\n<ol>\n<li>标签支持尺寸（size）属性，取值为: small、default和large，默认small</li>\n</ol>\n";